import React from "react";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";

export default function TopBar({ variant = "default", hideBrand = false }) {
  const { lang, setLang } = useLanguage();
  const toggle = () => setLang(lang === "fr" ? "en" : "fr");
  const isDark = variant === "transparent";
  return (
    <header
      className={`relative w-full px-4 sm:px-6 py-3 flex items-center justify-between z-10 ${
        isDark ? "text-white" : "text-[#2A0E3C]"
      }`}
    >
      {hideBrand ? (
        <span />
      ) : (
        <Link
          to="/"
          data-testid="topbar-brand"
          className="flex items-center gap-2"
        >
          <img
            src="/milkado-logo.png"
            alt="MILKADO"
            className="h-12 sm:h-14 w-auto object-contain"
          />
        </Link>
      )}
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={toggle}
          data-testid="lang-toggle"
          className={`gap-2 rounded-full ${
            isDark
              ? "text-white hover:bg-white/15 hover:text-white"
              : "text-[#2A0E3C] hover:bg-[#FCE7F3]"
          }`}
        >
          <Globe className="w-4 h-4" />
          <span className="text-xs font-bold uppercase tracking-widest">{lang}</span>
        </Button>
      </div>
    </header>
  );
}
